//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ShipDesign.js";
import "../no/Object.js";
import "../ShipDesign/ShipDesign.ShipSession.js";
let d=[[],[[["body_a","body_b"],"CheckBodyClash",{R_:{clash_status:''}},2,0],[["bodies","datum_plane"],"GetOutlineSheetbody",{R_:{outline_body:"Body"}},2,0],[["hull","inSheets","tolerence","numElementsIndex","elementIndex","numElements","outElements"],"AskPlatesSpatialRelations",{},3,0],[["plate","inSheets","tolerence","numElements","outElements"],"AskIntersectionPlates",{},3,0],[["inSheets","tolerence","numElements","outElements"],"CreateCargo",{},2,0],[["outSheet","inSheets","tolerence","numElements","outElements"],"GetSheetsEdgesLaidOnTargetSheet",{},3,0],[["numSteps","operationName"],"CreateProgress",{},2,0],[[],"DeleteProgress",{},0,0],[["stepNumber"],"AdvanceProgress",{},1,0],[[],"CheckAssemblyCircularReferences",{},0,0]],[]];
SPLM.ShipDesign.Generator = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ShipDesign.Generator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ShipDesign.Generator.ClashType = Object.freeze({
    "None" : "None", "AInB" : "AInB", "BInA" : "BInA", "Exists" : "Exists", "AbutNoClass" : "AbutNoClass", "AbutBInA" : "AbutBInA", "AbutBOutA" : "AbutBOutA", "Interfere" : "Interfere"});

export default SPLM;